module.exports = __webpack_public_path__ + "static/media/move-left.5bd4b770.svg";